import React from 'react'

const AddGuestWhiteSvg = ({ width }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 29 24'>
      <g id='Complete' transform='translate(0 -2.008)'>
        <g id='user-add' transform='translate(1 3)'>
          <g id='Group_1380' data-name='Group 1380'>
            <path
              id='Path_3268'
              data-name='Path 3268'
              d='M20.563,22.336V19.891A4.891,4.891,0,0,0,15.672,15H5.891A4.891,4.891,0,0,0,1,19.891v2.445'
              transform='translate(-1 -0.328)'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
            <circle
              id='Ellipse_249'
              data-name='Ellipse 249'
              cx='5'
              cy='5'
              r='5'
              transform='translate(5 0.008)'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
            <line
              id='Line_168'
              data-name='Line 168'
              x2='7'
              transform='translate(20 10.008)'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
            <line
              id='Line_169'
              data-name='Line 169'
              y2='7'
              transform='translate(23 6.008)'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AddGuestWhiteSvg
